import {
  Typography,
  Box,
} from "@mui/material";
import { ServiceAccordion } from "./service-accordion";

const formatServices = (services: any[] = []) => {
  return services.map((service) => ({
    ...service,
    id: service.serviceId,
    name: service.serviceName,

    // You don't have main service price → using first subservice price
    price: service.servicePrice,

    description: service.serviceDescription,

    subServices: (service.subServices || []).map((sub: any) => ({
      ...sub,
      id: sub.subServiceId,
      name: sub.subServiceName,
      price: sub.price,
      description: sub.subServiceDescription,
    })),

    merchandise: (service.merchandises || []).map((item: any) => ({
      ...item,
      id: item.merchandiseId,
      name: item.merchandiseName,
      price: item.price,
      description: item.merchandiseDescription,
    })),
  }));
};
export default function ServicesAndMerchandise({ packages }: { packages: any[] }) {
  const formattedPackages = formatServices(packages);
  return (
    <Box>
      {/* <Typography fontSize={18} fontWeight={500} color="#101828" fontStyle={"Inter"}>
       Services & Merchandise
      </Typography> */}

      {formattedPackages.map((service) => (
        <ServiceAccordion key={service.id} service={service} />
      ))}
    </Box>
  );
}